import { ControlledSelect } from 'components/Select/ControlledSelect';
import { SelectOptionType } from 'components/Select/Select';
import { useFormContext } from 'react-hook-form';
import style from './ReferralChannel.module.scss';

export type ReferralChannelSelectProps = {
  label: string;
  name: string;
  defaultChannel?: string;
  channels: SelectOptionType[];
};
const ReferralChannelSelect: React.FC<ReferralChannelSelectProps> = ({
  label,
  name,
  defaultChannel = '',
  channels = [],
}: ReferralChannelSelectProps) => {
  const { formState } = useFormContext();
  const error = formState.errors[name];

  return (
    <div>
      <ControlledSelect
        label={label}
        name={name}
        options={channels}
        defaultValue={defaultChannel}
      />
      {error && typeof error.message === 'string' && <p className={style.errorMsg}>{error.message}</p>}
    </div>
  );
};

export default ReferralChannelSelect;
